import React, { useContext } from "react";
import { useImmerReducer } from "use-immer";
import BreakpointContext from "../../contexts/breakpointContext";
import DraftDispatchContext from "../../contexts/draftDispatchContext";
import DraftStateContext from "../../contexts/draftStateContext";
import DraftLarge from "./DraftLarge";
import DraftMedium from "./DraftMedium";
import DraftSmall from "./DraftSmall";
import { draftInitialState, draftReducer } from "./draftReducer";
import styled from "styled-components";

const StyledContainerDiv = styled.div`
  & .react-tabs__tab-list li {
    font-size: ${(props) => props.tabFontSize};
    font-weight: bold;
    color: #0078f8;
  }

  & .react-tabs__tab-list li.react-tabs__tab {
    opacity: 0.75;
  }

  & .react-tabs__tab-list li.react-tabs__tab--selected {
    opacity: 1;
  }
`;

export default function LiveDraft() {
  const breakpoints = useContext(BreakpointContext);
  const [draftState, draftDispatch] = useImmerReducer(
    draftReducer,
    draftInitialState
  );

  let fontSize = "0.75rem";
  let tabFontSize = "0.8rem";

  let version;
  if (breakpoints.lg) version = <DraftLarge />;
  else version = breakpoints.md ? <DraftMedium /> : <DraftSmall />;

  return (
    <DraftDispatchContext.Provider value={draftDispatch}>
      <DraftStateContext.Provider value={draftState}>
        <StyledContainerDiv style={{ fontSize }} tabFontSize={tabFontSize}>
          {version}
        </StyledContainerDiv>
      </DraftStateContext.Provider>
    </DraftDispatchContext.Provider>
  );
}
